export default class modalImportCtrl {
  constructor($scope, $uibModal, $uibModalInstance, items1, httpRequest) {
    // 用户选择重复数据跳过/覆盖
    $scope.modalData = items1;
    $scope.comfirm = function comfirm(flag) {
      const importinglayer = layer.msg("操作中，请耐心等待", {
        time: 0,
        skin: "layer-loading-self",
        icon: 16,
        shade: 0.5,
      });
      $scope.modalData.detail.over = flag;
      httpRequest
        .post_confirmData($scope.modalData.detail)
        .then((confirmRes) => {
          // 初始化 详情弹窗参数 结果查询参数
          const { batchNo } = confirmRes.data.value;
          const { sourceCount } = confirmRes.data.value;
          const { errorCount } = confirmRes.data.value;
          const { dlType } = confirmRes.data.value;
          const _req = {
            pageNum: 1,
            pageSize: 10,
            param: batchNo,
          };
          // 请求错误信息
          httpRequest.post_getPageDlBatchInfoList(_req).then((res) => {
            // 关闭loading
            layer.close(importinglayer);
            // 获取导出信息详细数据
            const goodsImportRes = res.data.value;
            const modalData = {
              // 返回给弹窗的数据
              idToken: localStorage.id_token,
              params: {
                batchNo,
                sourceCount,
                successCount: sourceCount - errorCount,
                errorCount,
                data: goodsImportRes,
                dlType,
              },
            };
            // 弹窗实例
            const modalInstance = $uibModal.open({
              templateUrl: "importModalContent.html",
              controller: "modalImportCtrl",
              backdrop: "static",
              windowClass: "mod-modal-importexcel mod-modal mod-modal-lg",
              bindToController: true,
              resolve: {
                items1() {
                  return modalData;
                },
              },
            });
            // 弹窗回调
            modalInstance.result.then(
              () => {
                $scope.cancelModalConfirm();
              },
              () => {
                $scope.cancelModalConfirm();
              }
            );
          });
        });
    };

    // 关闭
    $scope.cancelModalConfirm = function (res) {
      $uibModalInstance.close(res);
    };
  }
}
modalImportCtrl.$inject = [
  "$scope",
  "$uibModal",
  "$uibModalInstance",
  "items1",
  "httpRequest",
];



// WEBPACK FOOTER //
// ./src/components/importexcel/modalConfirmCtrl.js